import ErrorMessage from "legacy/ErrorMessage"
import FormGroup from "legacy/FormGroup"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class DisableAutoRenewModal extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      arrival: this.props.arrival,
      departure: this.props.departure,
      showModal: false,
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.save = this.save.bind(this)
    this.handleDepartureChange = this.handleDepartureChange.bind(this)
  }

  handleDepartureChange(departure) {
    this.setState({ departure: moment(departure).format("YYYY-MM-DD") })
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  save() {
    this.setState({ saving: true })
    const params = {
      end_date: this.state.departure,
    }
    $.post(this.props.disableAutoRenewEndPoint, params, () => {
      location.reload()
    }).fail(() => {
      this.setState({
        errorMessage: "Error updating reservation.",
        saving: false,
      })
    })
  }

  render() {
    return (
      <div>
        <button
          type="button"
          className="btn btn-danger hidden-print"
          onClick={this.openModal}
        >
          End Auto Renewal
        </button>
        <Modal isOpen={this.state.showModal} onClose={this.closeModal}>
          <Modal.Header title="End Auto Renewal" />
          <Modal.Body>
            <p>
              Please pick a departure date for this reservation and this
              contract will no longer auto renew. This action cannot be undone.
            </p>
            <div className="row form-row">
              <div className="col-sm-4">
                <FormGroup
                  inputType="datepicker"
                  label="Departure"
                  name="departure"
                  value={this.state.departure}
                  onChange={this.handleDepartureChange}
                  startDate={this.props.arrival}
                />
              </div>
            </div>
            <ErrorMessage>{this.state.errorMessage}</ErrorMessage>
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Cancel"
            confirmBtnText="End Renewal"
            confirmBtnLoading={this.state.saving}
            onClose={this.closeModal}
            onSubmit={this.save}
          />
        </Modal>
      </div>
    )
  }
}

DisableAutoRenewModal.propTypes = {
  arrival: PropTypes.string.isRequired,
  departure: PropTypes.string.isRequired,
  disableAutoRenewEndPoint: PropTypes.string.isRequired,
}

export default DisableAutoRenewModal
